import { Component, Input } from '@angular/core';
import { Avatar, AvatarDetailPopup } from '../models';

@Component({
    selector: 'wdx-avatar-popup-content',
    templateUrl: './wdx-avatar-popup-content.component.html',
    standalone: false,
    host: { class: 'd-flex align-items-center p-2' },
})
export class AvatarPopupContentComponent {
    @Input() avatar?: Avatar;
    @Input() content?: AvatarDetailPopup;
}
